import CampaignStats from './CampaignStats.vue';

if (document.getElementById('campaign-stats-table')) {
  const table = document.getElementById('campaign-stats-table');

  var app = new Vue({
      el: table,
      template: `
        <CampaignStats
          :campaigns="this.campaigns"
          :seasonals="this.seasonals"
          :portables="this.portables"
          :orderedItems="this.orderedItems"
        />
      `,
      data(){
        return {
          campaigns: JSON.parse(table.dataset.campaigns),
          seasonals: JSON.parse(table.dataset.seasonals),
          portables: JSON.parse(table.dataset.portables),
          orderedItems: JSON.parse(table.dataset.orderedItems),
        };
      },
      created() {
          window.vue = this;
      },
      components: {
        CampaignStats
      },
  });
}